import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineProMypageListItem のスタイル
 */
export const hotlineProMypageListItemStyle = tv({
    slots: {
        additionalInfo: [
            textStyle({ color: 'textGray', size: 'sm' }),
            'flex flex-col lg:flex-row lg:flex-wrap max-lg:gap-8',
            'lg:divide-solid lg:divide-x lg:divide-gray-300 lg:divide-y-0',
        ],
        additionalInfoItem: ['lg:px-8 lg:first:pl-0'],
        base: ['list-none', 'bg-white'],
        contentInner: [
            'flex flex-col lg:flex-row lg:items-end gap-8 lg:gap-16',
            'w-full',
            'py-16',
        ],
        deadlineText: [textStyle({ color: 'base', size: 'sm' })],
        firstContent: ['flex flex-col gap-y-8', 'lg:flex-grow'],
        schedule: [
            textStyle({ color: 'base', isBold: true, size: 'sm' }),
            'flex items-center justify-start flex-wrap',
            'w-full lg:w-[309px]',
            'p-8 lg:py-16',
            'rounded-md',
            'bg-blue-gray-75',
            'lg:flex-shrink-0',
        ],
        scheduleValue: [textStyle({ isBold: true, size: 'md' })],
        title: ['block', 'line-clamp-2 lg:line-clamp-1', 'break-all'],
        top: ['flex flex-wrap gap-8'],
    },
    variants: {
        /** リンク無効表示か */
        disabled: {
            false: {
                contentInner: ['group'],
                title: [linkTextStyle({ isBold: true, isGroup: true, size: 'md' })],
            },
            true: {
                title: [textStyle({ color: 'base', isBold: true, size: 'md' })],
            },
        },
    },
});
